import React from 'react';
import { Link } from 'react-router-dom';
import { FiGift } from 'react-icons/fi';
import '../styles/Cart.css';

const GiftCards = () => {
  return (
    <div className="cart-page">
      <div className="cart-container">
        <div className="empty-cart">
          <div className="empty-cart-image" style={{ marginBottom: '20px' }}>
            <FiGift size={100} color="#ff3f6c" />
          </div>
          <h2>You don't have any Gift Cards!</h2>
          <p>Have a special occasion? Gift cards are the perfect way to celebrate.</p>
          <Link to="/products" className="add-from-wishlist-btn">
            BUY GIFT CARDS
          </Link>
        </div>
      </div>
    </div>
  );
};

export default GiftCards;
